import React from 'react';
import { ScrollView } from 'react-native';
import TextButton from 'src/components/10-atoms/button/TextButton';
import BookmarkIcon from 'src/components/10-atoms/icons/BookmarkIcon';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import Pressable from 'src/components/10-atoms/pressables/Pressable';
import ActionsBar from 'src/components/templates/ActionsBar';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
import QuestionReadingContent from '../../screens/Question/components/QuestionReadingContent';
import useData from '../../screens/Question/useData';
import useMarkQuestionReadOnDwell from '../../screens/Question/useMarkQuestionReadOnDwell';
const QuestionDetailPane = ({ question, selectedIndex, getQuestionTo, }) => {
    const [{ theme }] = useTheme();
    const { translate } = useI18n();
    const [state, actions] = useData({ questionID: question.id, question });
    useMarkQuestionReadOnDwell(question.id, state, actions);
    const questionDetails = state.questionDetailsQuery.data?.ep_questionDetails || question;
    const questionUserData = questionDetails?.userData;
    const openFullPageTo = getQuestionTo?.(question, selectedIndex);
    const handleBookmarkPress = useStableCallback(() => {
        if (questionUserData) {
            actions.updateBookmarkMutation.update({
                variables: {
                    questionID: question.id,
                    bookmark: !questionUserData.bookmarked,
                },
            });
        }
    });
    return (React.createElement(Column, { flex: true, style: { overflow: 'hidden' } },
        React.createElement(ActionsBar, { xAxis: 'flex-end' },
            React.createElement(Row, { yAxis: "center", spacing: theme.spacing.standard.sm },
                questionUserData && (React.createElement(Pressable, { onPress: handleBookmarkPress },
                    React.createElement(BookmarkIcon, { selected: questionUserData.bookmarked, size: theme.iconSize.md }))),
                openFullPageTo && (React.createElement(TextButton, { to: openFullPageTo, size: "sm" }, translate('Open full page'))))),
        React.createElement(ScrollView, { style: styleUtils.flex, contentContainerStyle: styleUtils.containerWidth },
            React.createElement(QuestionReadingContent, { questionID: question.id, question: question, state: state, actions: actions }))));
};
export default QuestionDetailPane;
